module.exports = __webpack_public_path__ + "img/Vector_3.b08c66f0.svg";